import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ExploreAppsCard } from "../../../components/ExploreAppsCard";
import { SelectLibraryCategory } from "../../../components/SelectLibraryCategory";
import {
  VideoLibraryCategories,
  VideoLibraryCategoryBgs,
  videoLibraryItem,
} from "../../../InspirationLibraryHelper";
import { useGetInspirationLibraryVideoItems } from "../../../../../store/Apis/InspirationLibraryApi";
import { VideoLibraryItems } from "./VideoLibraryItems";
import CircularProgress from "@mui/material/CircularProgress";

export const VideoLibraryContainer = () => {
  const [activeCategory, setActiveCategory] = useState(0);
  const { data: videoLibCategoriesData, isPending: isVideoLibraryLoading } =
    useGetInspirationLibraryVideoItems({ Category: activeCategory });
  const [videoLibraryItems, setVideoLibraryItems] = useState<
    videoLibraryItem[]
  >([]);

  const handleSelectActiveCategory = (category: number) => {
    setActiveCategory(category);
  };

  useEffect(() => {
    if (videoLibCategoriesData) setVideoLibraryItems(videoLibCategoriesData);
  }, [videoLibCategoriesData]);

  return (
    <Box className="library-app-container">
      <ExploreAppsCard exploreRoute="/suites/video-suite" />
      <SelectLibraryCategory
        categories={VideoLibraryCategories}
        activeCategory={activeCategory}
        setActiveCategory={handleSelectActiveCategory}
        categoriesBgs={VideoLibraryCategoryBgs}
      />
      {isVideoLibraryLoading ? (
        <Box
          sx={{
            width: "100%",
            height: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <VideoLibraryItems
            activeCategory={activeCategory}
            videoLibraryItems={videoLibraryItems}
          />
        </>
      )}
    </Box>
  );
};
